<template>
  <div class="px-4">
    <div
      class="d-flex justify-space-between align-center cursor-pointer py-2"
      @click="$emit('change')"
    >
      <p class="subtitle-2 blue-grey--text text--darken-3 font-weight-bold ">
        {{ name }}
      </p>
      <v-btn icon x-small>
        <v-icon size="24" color="blue-grey darken-1">{{ icon }}</v-icon>
      </v-btn>
    </div>
    <v-divider v-if="isActive" />
  </div>
</template>

<script>
export default {
  name: 'FilterHeader',

  props: {
    name: { type: String, required: true },
    isActive: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    icon() {
      return this.isActive ? 'mdi-chevron-up' : 'mdi-chevron-down'
    },
  },
}
</script>
